// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_l3-0";
export var discountCodeInput = "_l3-1";